<template>
    <article :id="`menu-item-${id}`" class="text-center basis-1/3">
        <h4 class="h7">{{ name }}</h4>
        <p v-if="description" class="text-sm text-gray">{{ description }}</p>

        <div v-if="price" class="mt-1.5">${{ price }}</div>

        <ul v-else-if="options" class="text-xs mt-1.5 flex flex-col gap-y-2">
            <li v-for="(option, idx) in options" :key="`menu-item-${id}-option-${idx}`" class="flex flex-col gap-y-1">
                <span>{{ option.name }}</span>
                <span>${{ option.price }}</span>
            </li>
        </ul>
    </article>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    id: { type: [Number, String], required: true },
    name: { type: String, required: true },
    description: { type: String, default: null },
    cost: { type: Object, default: () => ({}) }, 
});

const price = computed(() => {

    if(props.cost && props.cost.type == 'PRICE') {
        return props.cost.price;
    }

    return null;
});

const options = computed(() => {
    if(props.cost && props.cost.type == 'NONE' && props.cost.options) {
        return props.cost.options;
    }

    return null;
})
</script>
